import Avatar from "antd/es/avatar/Avatar";
import moment from "moment";
import React, { useCallback, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Modal as AntdModal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import Toasts from "../../../core/common/toast";
import { API_URLS, BASE_URLS } from "../../../core/data/redux/apis/urls";
import {
  getEmployees,
  syncFromSap,
  bulkUpdateLoginStatus,
} from "../../../core/data/redux/employeesSlice";
import Api from "../../../core/data/redux/utils/apiCall";
import { useDebounce } from "../../../core/hooks/useDebounce";
import { all_routes } from "../../router/all_routes";
import Offices from "./offices";
import Roles from "./roles";
import { Switch } from "antd";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ChangePassword from "./change_password";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import PermissionsAccordion from "./permissionsAccordionModal";
import PermissionsAccordionModal from "./permissionsAccordionModal";
import SyncNocRequest from "../noc/sync-noc-request";
import { ResetLoginFailed } from "../../../core/data/redux/resetLoginSlice";
import { formatEmployeeId } from "../../../core/utils/employeeUtils";
import PermissionGuard from "../../permissionGuard";
import { isSupportViewer } from "../../../utils/permissionUtils";


interface EmployeesListProps { }

const EmployeesList = (props: EmployeesListProps) => {
  const location = useLocation();
  const stateFilters = location.state as any;

  const [currentItem, setCurrentItem] = useState<any>(null);
  const dispatch = useDispatch();
  const employeesState = useSelector((state: any) => state.employeesState);
  const [dataList, setDataList] = React.useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [bulkLoginStatus, setBulkLoginStatus] = useState<string>("");
  const routes = all_routes;
  const [query, setQuery] = useState<any>("");
  const [showCsvLoader, seShowCsvLoader] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState<{ show: boolean; empId: string } | null>(null);
  const [showLoc, setShowLoc] = React.useState<any[] | null>(null);

  // const [isPermissionModalOpen, setIsPermissionModalOpen] = useState(false);
  // const [checkedPermissions, setCheckedPermissions] = useState<number[]>([]);

  const [showPermissionModal, setShowPermissionModal] = useState<{ show: boolean; empId: string } | null>(null);

  const [syncModalOpen, setSyncModalOpen] = useState(false);
  const [syncingLoan, setSyncingLoan] = useState(false);
  const [loginToggleConfirm, setLoginToggleConfirm] = useState<{ show: boolean; empId: string; login_on: boolean } | null>(null);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 10,
  });

  // Store current filter values to persist across pagination
  const [currentFilters, setCurrentFilters] = useState<any>({
    query: "",
    empStatus: stateFilters?.empStatus || "",
    loginStatus: stateFilters?.loginStatus || "",
    employmentType: "",
    reporterId: "",
  });

  // Statistics data from API
  const [statistics, setStatistics] = useState({
    total: 0,
    active: 0,
    inactive: 0,
    total_withdrawn_employee: 0,
  });

  // Fetch statistics data from API
  const getStatisticsData = async () => {
    try {
      const endPoint = `${BASE_URLS.BASE_URL}dashboard/admin-dashboard`;
      const response = await Api.post(`${endPoint}`, {});
      return response.data;
    } catch (error: any) {
      return "";
    }
  };

  // Fetch statistics on component mount
  React.useEffect(() => {
    const fetchStatisticsData = async () => {
      const data = await getStatisticsData();
      if (data && data.data) {
        setStatistics({
          total: (data.data.total_active_employee || 0) + (data.data.total_inactive_employee || 0) + (data.data.total_withdrawn_employee || 0) + (data.data.total_retiree_employee || 0),
          active: data.data.total_active_employee || 0,
          inactive: (data.data.total_inactive_employee || 0) + (data.data.total_withdrawn_employee || 0),
          total_withdrawn_employee: data.data.total_withdrawn_employee || 0,
        });
      }
    };
    fetchStatisticsData();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      query: currentFilters.query || "",
      empStatus: currentFilters.empStatus || "",
      loginStatus: currentFilters.loginStatus || "",
      employmentType: currentFilters.employmentType || "",
      reporterId: currentFilters.reporterId || "",
    },
  });

  const onSubmit = async (data: any) => {
    // Trim and normalize search values (pad numeric employee IDs to 8 digits)
    const trimmedQuery = formatEmployeeId(data.query);
    const trimmedReporterId = formatEmployeeId(data.reporterId);

    if (trimmedQuery !== data.query) {
      setValue("query", trimmedQuery);
    }
    if (trimmedReporterId !== data.reporterId) {
      setValue("reporterId", trimmedReporterId);
    }

    // Store filter values in state
    const filters = {
      query: trimmedQuery,
      empStatus: data.empStatus || "",
      loginStatus: data.loginStatus || "",
      employmentType: data.employmentType || "",
      reporterId: trimmedReporterId,
    };
    setCurrentFilters(filters);

    // Reset to page 1 when filters change
    const resetPagination = { ...pagination, current: 1 };
    setPagination(resetPagination);

    // Build request payload, only including non-empty filter values
    const requestPayload: any = {
      page: 1,
      limit: pagination.pageSize,
    };

    // Only add filter parameters if they have values
    // When both query and reporterId are empty, fetch all employees
    if (trimmedQuery) {
      requestPayload.query = trimmedQuery;
    }
    if (filters.empStatus) {
      requestPayload.empStatus = filters.empStatus;
    }
    if (filters.loginStatus) {
      requestPayload.loginStatus = filters.loginStatus;
    }
    if (filters.employmentType) {
      requestPayload.employmentType = filters.employmentType;
    }
    if (trimmedReporterId) {
      requestPayload.reporterId = trimmedReporterId;
    }

    // Explicitly reset and fetch all when both search fields are empty
    dispatch(getEmployees(requestPayload));
  }


  // const fetchRecords = useCallback(
  //   (pagination: any, query: string) => {
  //     console.log('pagination>>', pagination)
  //     dispatch(
  //       getEmployees({
  //         page: pagination.current,
  //         limit: pagination.pageSize,
  //         query: query,
  //       })
  //     );
  //   },
  //   [dispatch]
  // );

  const fetchRecords = useCallback(
    (pagination: any, filters: any, orderColumn?: string, orderBy?: string) => {
      // Build request payload, only including non-empty filter values
      const requestPayload: any = {
        page: pagination.current,
        limit: pagination.pageSize,
        orderBy: orderBy || "ASC",         // Default to ASC
        orderColumn: orderColumn || null,     // empId, firstname, etc.
      };

      // Only add filter parameters if they have values
      if (filters.query && filters.query.trim()) {
        const searchVal = formatEmployeeId(filters.query);
        requestPayload.query = searchVal;
      }
      if (filters.empStatus) {
        requestPayload.empStatus = filters.empStatus;
      }
      if (filters.loginStatus) {
        requestPayload.loginStatus = filters.loginStatus;
      }
      if (filters.employmentType) {
        requestPayload.employmentType = filters.employmentType;
      }
      if (filters.reporterId && filters.reporterId.trim()) {
        const reporterVal = formatEmployeeId(filters.reporterId);
        requestPayload.reporterId = reporterVal;
      }

      dispatch(getEmployees(requestPayload));
    },
    [dispatch]
  );

  const handleResetLogin = async (empId: string) => {
    try {
      // Step 1: Confirmation
      const confirmed = window.confirm(
        "Are you sure you want to reset login attempts for this employee?"
      );

      if (!confirmed) return;

      // Step 2: Dispatch API
      const response: any = await dispatch(ResetLoginFailed({ empId: empId }) as any).unwrap();

      // Step 3: Success message
      toast.success("Login failed attempts have been reset successfully!");

      console.log("Reset Login Response:", response);

      // Refresh the data
      fetchRecords(pagination, currentFilters);
    } catch (error: any) {
      // Step 4: Failure handling
      toast.error(error || "Failed to reset login attempts.");
    }
  };

  // Handle row selection - similar to office location pattern
  const handleOnRowSelection = (selectedRowKeys: any[]) => {
    setSelectedRows(selectedRowKeys);
    // Reset status when selection changes (like office location)
    setBulkLoginStatus("");
  };

  // Bulk update login status function - exactly like office location pattern
  const handleBulkLoginStatusChange = async () => {
    if (selectedRows.length === 0) {
      toast.warning("Please select at least one employee.");
      return;
    }

    if (!bulkLoginStatus) {
      toast.warning("Please select a status.");
      return;
    }

    // Get employee IDs from selected rows
    // The selectedRows contains the keys (id or empId or index) from the table
    const selectedRecords = dataList.filter((record, index) => {
      const recordKey = record.id || record.empId || index;
      return selectedRows.includes(recordKey) ||
        selectedRows.includes(record.id) ||
        selectedRows.includes(record.empId) ||
        selectedRows.includes(index);
    });

    const employeeIds = selectedRecords
      .map(record => record.empId)
      .filter(id => id !== null && id !== undefined) as string[];

    if (employeeIds.length === 0) {
      toast.error("No valid employee IDs found in selected records.");
      return;
    }

    // Map status to login_on boolean - exactly like office location
    const login_on = bulkLoginStatus === 'Active' ? true : false;

    // Call API directly - no confirmation modal, just like office location
    try {
      await dispatch(
        bulkUpdateLoginStatus({
          empIds: employeeIds,
          login_on: login_on,
        }) as any
      ).unwrap();

      // Reset state and refresh data - exactly like office location
      setSelectedRows([]);
      setBulkLoginStatus("");

      // Refresh the data
      fetchRecords(pagination, currentFilters);
    } catch (error: any) {
      toast.error(error || "Failed to update login status.");
    }
  };


  const handleSync = (empId: string) => {
    dispatch(syncFromSap({ empId: empId }));
  };

  const handleSyncLoanData = async (empId: string) => {
    try {
      setSyncingLoan(true);
      const endPoint = API_URLS.SAP_LOAN_REQUESTS.SYNC_BY_EMPLOYEE;
      const payload = empId ? { empId } : {};
      const response = await Api.post(endPoint, payload);
      const msg = response?.data?.message || response?.message || "Loan Data Synced successfully";
      toast.success(msg);
    } catch (error: any) {
      console.error("Loan sync failed", error);
      toast.error(Api.getErrorMessage(error) || "Failed to sync loan data");
    } finally {
      setSyncingLoan(false);
    }
  };

  // Debounced search function (500ms delay)
  // const debouncedFetchRecords = useDebounce(
  //   (pagination: any, query: string) => {
  //     fetchRecords(pagination, query);
  //   },
  //   500
  // );

  const handleSearch = (query: string) => {
    setQuery(query);
    const updatedFilters = { ...currentFilters, query };
    setCurrentFilters(updatedFilters);
    const searchPagination = { ...pagination, current: 1 };
    setPagination(searchPagination);
    fetchRecords(searchPagination, updatedFilters);
  };

  const handleReporterIdSearch = (reporterId: string) => {
    const updatedFilters = { ...currentFilters, reporterId };
    setCurrentFilters(updatedFilters);
    const searchPagination = { ...pagination, current: 1 };
    setPagination(searchPagination);
    fetchRecords(searchPagination, updatedFilters);
  };

  // Initial load on component mount
  React.useEffect(() => {
    fetchRecords(pagination, currentFilters);
  }, []); // Empty dependency array - only run on mount



  const handleLoginToggle = async (empId: string) => {
    try {
      const response = await Api.post(API_URLS.EMPLOYEES.TOGGLE_LOGIN_ON_OFF, { empId: empId });
      toast.success(response?.data?.message)
      setLoginToggleConfirm(null);
      // Refresh with current filters preserved
      fetchRecords(pagination, currentFilters);
    } catch (error: any) {
      toast.error(error?.response?.data?.message ||
        error?.response?.data?.data?.message ||
        "Failed to fetch data")
      setLoginToggleConfirm(null);
    }
  };


  React.useEffect(() => {
    if (
      employeesState.loading === "fulfilled" &&
      (employeesState.action === "assign" ||
        employeesState.action === "assign-role" ||
        employeesState.action === "sync-from-sap" ||
        employeesState.action === "bulk-update-login-status")
    ) {
      setTimeout(() => {
        // Refresh with current filters preserved
        fetchRecords(pagination, currentFilters);
      }, 2000);
    } else if (
      employeesState.loading === "fulfilled" &&
      employeesState.action === "list"
    ) {
      const result = employeesState?.data?.data || null;
      if (result.data && result.data.length > 0) {
        const employees = result?.data || [];
        setDataList(employees);
        setPagination({
          ...pagination,
          total: result.total || employees.length,
          current: result.page || 1,
          pageSize: result.limit || 10,
        });
      } else {
        setDataList([]);
      }
    }
  }, [employeesState.loading]);
  const randomAvatar = (firstName: string) => {
    const colors = [
      "#f56a00",
      "#7265e6",
      "#ffbf00",
      "#00a2ae",
      "#87d068",
      "#d46b08",
    ];
    const index = Math.floor(Math.random() * colors.length);
    const initial = firstName?.charAt(0)?.toUpperCase() || "?";
    return {
      bg: colors[index],
      initial,
    };
  };
  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      width: 100,
      render: (text: string, record: any, index: number) => (
        <>
          <div>
            {pagination.current
              ? index +
              pagination.current * pagination.pageSize -
              pagination.pageSize +
              1
              : index + 1}
          </div>
        </>
      ),
      //sorter: (a: any, b: any) => a.id.length - b.id.length,
    },

    {
      title: "Name",
      dataIndex: "details",
      render: (details: any, record: any) => {
        const first = details?.firstname?.trim() || "";
        const last =
          details?.lsastname?.trim() || details?.lastname?.trim() || "";

        if (!first && !last) {
          return <div style={{ height: "40px" }}></div>;
        }

        const avatarInfo = randomAvatar(first);

        return (
          <Link
            to={`/employees/profile/${record.id}`}
            className="d-flex align-items-center text-decoration-none"
            style={{ color: "inherit" }}
          >
            {details?.image ? (
              <Avatar
                src={`data:image/jpeg;base64,${details.image}`}
                className="me-2"
                style={{
                  backgroundColor: avatarInfo.bg,
                  verticalAlign: "middle",
                  width: "50px",
                  height: "50px",
                }}
              ></Avatar>
            ) : (
              <Avatar
                className="me-2"
                style={{
                  backgroundColor: avatarInfo.bg,
                  verticalAlign: "middle",
                  width: "50px",
                  height: "50px",
                }}
              >
                {avatarInfo.initial}
              </Avatar>
            )}
            <div className="text-primary">{`${first} ${last}`.trim()}</div>
          </Link>
        );
      },
    },

    {
      title: "Login Status",
      dataIndex: "login_on",
      render: (login_on: boolean, record: any) => (
        <Switch
          disabled={isSupportViewer()}
          checked={!!login_on}
          checkedChildren="Enabled"
          unCheckedChildren="Disabled"
          onChange={() => setLoginToggleConfirm({ show: true, empId: record.empId, login_on: !!login_on })}
        />
      ),
    },

    {
      title: "Emp Id",
      dataIndex: "empId",
      sorter: (a: any, b: any) => parseInt(a.empId) - parseInt(b.empId),
      render: (empId: string) => parseInt(empId, 10),
    },

    {
      title: "Email",
      dataIndex: "details",
      render: (details: any) => details?.email || "-",
    },

    {
      title: "Phone",
      dataIndex: "details",
      render: (details: any) => details?.phone || "-",
    },

    {
      title: "Employee Status",
      dataIndex: "details",
      render: (details: any) => details?.empStatus || "-",
    },

    {
      title: "Employment Type",
      dataIndex: "details",
      render: (details: any) => details?.employmentType || "-",
    },

    {
      title: "Date of Birth",
      dataIndex: "details",
      render: (details: any) =>
        moment(details?.birthdate).format("DD-MM-YYYY") || "-",
    },

    {
      title: "Joining Date",
      dataIndex: "details",
      render: (details: any) =>
        moment(details.date_of_joining).format("DD-MM-YYYY") || "-",
    },

    {
      title: "Wing",
      dataIndex: "details",
      render: (details: any) =>
        details?.sap_department_designation_wings?.wing_name || "-",
    },

    {
      title: "Department",
      dataIndex: "details",
      render: (details: any) =>
        details?.sap_department_designation_wings?.department_name || "-",
    },

    {
      title: "Designation",
      dataIndex: "details",
      render: (details: any) =>
        details?.sap_department_designation_wings?.designation_name || "-",
    },

    {
      title: "Reporting Manager",
      dataIndex: "details",
      render: (details: any) => {
        if (!details?.reportingManagerID) return "-";

        const managerId = parseInt(details.reportingManagerID, 10);
        const managerName =
          details?.reportingManagerName || details?.manager?.firstname
            ? `${details.manager?.firstname || ""} ${details.manager?.lsastname || ""
              }`.trim()
            : "";

        if (managerName) {
          return `${managerId} - ${managerName}`;
        }
        return managerId;
      },
    },

    {
      title: "Role",
      dataIndex: "hrms_role",
      render: (hrms_role: any) => hrms_role?.role?.role_name || "",
    },

    {
      title: "Actions",
      dataIndex: "actions",
      width: 100,
      render: (text: string, record: any, index: number) => (
        <div className="action-icon d-inline-flex" style={{ gap: 10 }}>
          <PermissionGuard route="employees/assign-permission">
            <button
              className="btn btn-info btn-sm"
              onClick={() => {
                setShowPermissionModal({ show: true, empId: record.empId });
              }}
            >
              Assign Permission
            </button>
          </PermissionGuard>

          {record?.offices && record?.offices.length > 0 && (
            <button
              className="btn btn btn-sm"
              onClick={() => setShowLoc(record?.offices)}
            >
              <i className="ti ti-ti ti-building"></i>
            </button>
          )}

          <PermissionGuard route="employees/assign-office">
            <button
              className="btn btn-info btn-sm"
              data-bs-toggle="modal"
              data-inert={true}
              data-bs-target="#assign_office_modal"
              onClick={() => setCurrentItem(record)}
            >
              Assign Office
            </button>
          </PermissionGuard>

          <PermissionGuard route="employees/assign-role">
            <button
              className="btn btn-info btn-sm"
              data-bs-toggle="modal"
              data-inert={true}
              data-bs-target="#assign_role_modal"
              onClick={() => setCurrentItem(record)}
            >
              Assign Role
            </button>
          </PermissionGuard>

          <PermissionGuard route="employees/sync" isSync={true}>
            <button
              className="btn btn-info btn-sm"
              onClick={() => {
                setCurrentItem(record.empId);
                setSyncModalOpen(true);
              }}
            >
              <i className="ti ti-refresh"></i> Sync From SAP
            </button>
          </PermissionGuard>

          <PermissionGuard route="employees/change-password">
            <button
              className="btn btn-info btn-sm"
              onClick={() => setShowChangePassword({ show: true, empId: record.empId })}
            >
              Change Password
            </button>
          </PermissionGuard>

          <PermissionGuard route="employees/unlock">
            <button
              className="btn btn-info btn-sm"
              onClick={() => handleResetLogin(record.empId)}
            >
              Unlock
            </button>
          </PermissionGuard>
        </div>
      ),
    },
  ];

  // const handlePagination = (pagination: any) => {

  //   console.log('pagination', pagination)
  //   setPagination({
  //     current: pagination.page,
  //     pageSize: pagination.pageSize,
  //     total: pagination.total || 10,
  //   });
  //   fetchRecords(pagination, query);
  // };

  const handlePagination = (newPagination: any, filters: any, sorter: any) => {
    const orderColumn = sorter?.field || null;

    // Ant Design Table sorting cycle: 
    // 1st click: "ascend" -> ASC
    // 2nd click: "descend" -> DESC  
    // 3rd click: undefined/null -> no sort (defaults to ASC)
    let orderBy = "ASC"; // Default

    if (sorter?.order === "ascend") {
      orderBy = "ASC";
    } else if (sorter?.order === "descend") {
      orderBy = "DESC";
    } else if (sorter?.order === undefined || sorter?.order === null) {
      // No sort selected - default to ASC
      orderBy = "ASC";
    }

    console.log('Sort Debug:', {
      sorterOrder: sorter?.order,
      orderColumn,
      orderBy,
      fullSorter: sorter
    });

    setPagination((prev) => {
      const isPageSizeChanged = prev.pageSize !== newPagination.pageSize;
      const updatedPagination = {
        current: isPageSizeChanged ? 1 : newPagination.current || 1,
        pageSize: newPagination.pageSize,
        total: newPagination.total || prev.total,
        orderColumn,
        orderBy,
      };

      // Use currentFilters to preserve all filter values during pagination
      fetchRecords(updatedPagination, currentFilters, orderColumn, orderBy);

      return updatedPagination;
    });
  };

  const handleDownloadCsv = async () => {
    seShowCsvLoader(true);
    try {
      const response = await Api.post(API_URLS.EMPLOYEES.EXPORT_CSV, {});
      console.log(response);
      if (response) {
        const csvData = response;
        const blob = new Blob([csvData], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "employees.csv";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
      seShowCsvLoader(false);
    } catch (error) {
      seShowCsvLoader(false);
      Toasts({
        show: true,
        message: "Failed to download CSV",
        title: "Error",
        type: "danger",
      });
    }
  };



  return (
    <div>
      <>
        <Toasts
          show={employeesState.loading === "rejected"}
          message={employeesState.error}
          title={"Failed"}
          type={"danger"}
        />
        <Toasts
          show={
            employeesState.loading === "fulfilled" &&
            employeesState.action != "list"
          }
          message={employeesState?.data?.message}
          title={"Success"}
          type={"success"}
        />
        <div className="page-wrapper">
          <div className="content">
            {/* Header with Export Button */}
            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
              <div className="my-auto mb-2">
                <h3 className="page-title mb-1">Employee</h3>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="#">Employee</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Employee List
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="mb-2">
                <button
                  className="btn btn-info btn-sm"
                  onClick={handleDownloadCsv}
                >
                  <i className="ti ti-ti ti-csv"></i> Export
                </button>
              </div>
            </div>

            {/* Statistics Cards */}
            <div className="row mb-4">
              <div className="col-md-3 col-sm-6 mb-3">
                <div className="card border-0 shadow-sm">
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h6 className="text-muted mb-2">Total Employee</h6>
                        <h3 className="mb-0">{statistics.total}</h3>
                      </div>
                      <div className="avatar avatar-md bg-primary-transparent rounded-circle">
                        <i className="ti ti-users fs-20 text-primary"></i>
                      </div>
                    </div>
                    <div className="mt-2">
                      {/* <small className="text-success">
                        <i className="ti ti-arrow-up"></i> +19.01%
                      </small> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 mb-3">
                <div className="card border-0 shadow-sm">
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h6 className="text-muted mb-2">Active</h6>
                        <h3 className="mb-0">{statistics.active}</h3>
                      </div>
                      <div className="avatar avatar-md bg-success-transparent rounded-circle">
                        <i className="ti ti-user-check fs-20 text-success"></i>
                      </div>
                    </div>
                    <div className="mt-2">
                      {/* <small className="text-warning">
                        <i className="ti ti-arrow-up"></i> +19.01%
                      </small> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 mb-3">
                <div className="card border-0 shadow-sm">
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h6 className="text-muted mb-2">InActive</h6>
                        <h3 className="mb-0">{statistics.inactive}</h3>
                      </div>
                      <div className="avatar avatar-md bg-danger-transparent rounded-circle">
                        <i className="ti ti-user-x fs-20 text-danger"></i>
                      </div>
                    </div>
                    <div className="mt-2">
                      {/* <small className="text-warning">
                        <i className="ti ti-arrow-up"></i> +19.01%
                      </small> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 mb-3">
                <div className="card border-0 shadow-sm">
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h6 className="text-muted mb-2">Withdrawn Employees</h6>
                        <h3 className="mb-0">{statistics.total_withdrawn_employee}</h3>
                      </div>
                      <div className="avatar avatar-md bg-info-transparent rounded-circle">
                        <i className="ti ti-user-plus fs-20 text-info"></i>
                      </div>
                    </div>
                    <div className="mt-2">
                      {/* <small className="text-warning">
                        <i className="ti ti-arrow-up"></i> +19.01%
                      </small> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Table Card */}

            <div className="card">
              {/* First Row: Employee List Title + Filters */}
              <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
                <div>
                  <h3 className="page-title mb-0">Employee List</h3>
                </div>
                <div className="d-flex align-items-center gap-2">

                  <form onSubmit={handleSubmit(onSubmit)} className="d-flex align-items-center gap-2">
                    <select className="form-control form-control-sm" style={{ minWidth: '150px' }} {...register("loginStatus")}>
                      <option value="">Login Status</option>
                      <option value={'Active'}>Enabled</option>
                      <option value={'Withdrawn'}>Disabled</option>
                    </select>
                    <select className="form-control form-control-sm" style={{ minWidth: '150px' }} {...register("empStatus")}>
                      <option value="">Select Status</option>
                      <option value={'Active'}>Active</option>
                      <option value={'Withdrawn'}>Withdrawn</option>
                      <option value={'Inactive'}>Inactive</option>
                    </select>
                    <select className="form-control form-control-sm" style={{ minWidth: '150px' }} {...register("employmentType")}>
                      <option value="">Designation</option>
                      <option value={'Deputation'}>Deputation</option>
                      <option value={'Direct Recruit'}>Direct Recruit</option>
                      <option value={'Consultant'}>Consultant</option>
                      <option value={'Temporary'}>Temporary</option>
                      <option value={'Compassionate Appointment'}>Compassionate Appointment</option>
                      <option value={'Reemployed'}>Reemployed</option>
                    </select>
                    {/* <select className="form-control form-control-sm" style={{ minWidth: '180px' }}>
                      <option value="">Sort By: Last 7 Days</option>
                      <option value="today">Today</option>
                      <option value="week">Last 7 Days</option>
                      <option value="month">Last 30 Days</option>
                      <option value="year">This Year</option>
                    </select> */}
                    <input
                      type="search"
                      className="form-control form-control-sm"
                      style={{ maxWidth: '300px' }}
                      placeholder="Search by Emp ID / Name"
                      {...register("query")}
                      onBlur={(e) => {
                        const val = e.target.value;
                        const formatted = formatEmployeeId(val);
                        if (formatted !== val) {
                          setValue("query", formatted);
                        }
                      }}
                    />
                    <input
                      type="search"
                      className="form-control form-control-sm"
                      style={{ maxWidth: '300px' }}
                      placeholder="Search by Reporter ID"
                      {...register("reporterId")}
                      onBlur={(e) => {
                        const val = e.target.value;
                        const formatted = formatEmployeeId(val);
                        if (formatted !== val) {
                          setValue("reporterId", formatted);
                        }
                      }}
                    />
                    <button
                      type="submit"
                      className="btn btn-info btn-sm"
                    >
                      Search
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => {
                        const emptyFilters = {
                          query: "",
                          empStatus: "",
                          loginStatus: "",
                          employmentType: "",
                          reporterId: "",
                        };
                        reset(emptyFilters);
                        setCurrentFilters(emptyFilters);
                        const resetPagination = { ...pagination, current: 1 };
                        setPagination(resetPagination);
                        fetchRecords(resetPagination, emptyFilters);
                      }}
                    >
                      Reset
                    </button>
                  </form>
                </div>
              </div>

              {/* Second Row: Row Per Page + Search */}
              {/* <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
                <div className="d-flex align-items-center">
                  <label className="me-2 mb-0">Row Per Page:</label>
                  <select
                    className="form-control form-control-sm"
                    style={{ width: 'auto' }}
                    value={pagination.pageSize}
                    onChange={(e) => {
                      const newPagination = { ...pagination, pageSize: parseInt(e.target.value), current: 1 };
                      setPagination(newPagination);
                      fetchRecords(newPagination, currentFilters);
                    }}
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                  <span className="ms-2">Entries</span>
                </div>
                <div>
                  <input
                    type="search"
                    className="form-control form-control-sm"
                    style={{ maxWidth: '300px' }}
                    placeholder="Search by Emp ID"
                    value={query}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                </div>
              </div> */}

              <div className="card-body p-0 py-3">
                <div className="flex justify-content-end">
                  {selectedRows.length > 0 && (
                    <div className="d-flex align-items-center gap-2 p-3 border-bottom">
                      <div className="dropdown">
                        <button
                          className="btn btn-white dropdown-toggle d-inline-flex align-items-center"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {bulkLoginStatus || `Select Login Status (${selectedRows.length})`}
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end p-3">
                          <li>
                            <Link
                              to="#"
                              className={`dropdown-item rounded-1 ${bulkLoginStatus === "Active" ? "active" : ""}`}
                              onClick={(e) => {
                                e.preventDefault();
                                setBulkLoginStatus("Active");
                              }}
                            >
                              Enable
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="#"
                              className={`dropdown-item rounded-1 ${bulkLoginStatus === "Inactive" ? "active" : ""}`}
                              onClick={(e) => {
                                e.preventDefault();
                                setBulkLoginStatus("Inactive");
                              }}
                            >
                              Disable
                            </Link>
                          </li>
                        </ul>
                      </div>
                      {bulkLoginStatus && (
                        <button
                          className="btn btn-primary btn-sm"
                          type="button"
                          onClick={handleBulkLoginStatusChange}
                        >
                          Change Status
                        </button>
                      )}
                    </div>
                  )}
                </div>
                <Table
                  columns={columns}
                  dataSource={dataList.map((item, index) => ({ ...item, key: item.id || item.empId || index }))}
                  Selection={true}
                  paginationConfig={pagination}
                  handlePagination={handlePagination}
                  loading={
                    employeesState.loading === "pending" &&
                    employeesState.action === "list"
                  }
                  handleSearch={handleSearch}
                  onRowSelection={handleOnRowSelection}
                >
                </Table>
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="datatable-paginate mt-4" />
              </div>
            </div>
          </div>
        </div>
      </>

      <div
        className="modal fade"
        id="assign_office_modal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="assignOfficeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Assign office</h4>
                <span>
                  Employee ID : {parseInt(currentItem?.emp_id || "0", 10)}
                </span>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <Offices employee={currentItem} />
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="assign_role_modal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="assignOfficeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Assign Role</h4>
                <span>
                  Employee ID : {parseInt(currentItem?.emp_id || "0", 10)}
                </span>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <Roles employee={currentItem} />
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showLoc && showLoc.length > 0 ? true : false}
        onHide={() => setShowLoc(null)}
      >
        <div className="modal-header bg-dark modal-bg">
          <div className="modal-title text-white">
            <span id="eventTitle">Assigned Offices</span>
          </div>
          <button
            type="button"
            className="btn-close custom-btn-close"
            onClick={() => setShowLoc(null)}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body">
          {showLoc?.map((item: any) => {
            return <div>{item.officeLocation.name}</div>;
          })}
        </div>
      </Modal>
      <ChangePassword showModal={showChangePassword} handleModal={() => setShowChangePassword(null)} />
      <PermissionsAccordionModal showModal={showPermissionModal} handleModal={() => setShowPermissionModal(null)} />
      <Modal show={loginToggleConfirm?.show} onHide={() => setLoginToggleConfirm(null)} centered>
        <div className="modal-header">
          <h5 className="modal-title">Confirm Action</h5>
          <button type="button" className="btn-close" onClick={() => setLoginToggleConfirm(null)}></button>
        </div>
        <div className="modal-body pt-4 pb-4">
          <p className="mb-0">
            Are you sure you want to <strong>{loginToggleConfirm?.login_on ? 'Disable' : 'Enable'}</strong> this employee?
          </p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-outline-secondary me-2" onClick={() => setLoginToggleConfirm(null)}>
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={() => {
            if (loginToggleConfirm?.empId) {
              handleLoginToggle(loginToggleConfirm.empId);
            }
          }}>
            Confirm
          </button>
        </div>
      </Modal>
      <AntdModal
        open={syncModalOpen}
        onCancel={() => {
          setCurrentItem(null);
          setSyncModalOpen(false)
        }
        }
        title={'Sync Employee Data'}
        footer={null}
      >

        <div className="row">
          <div className="col-md-12 mt-4">
            <button
              className="btn btn-primary w-100"
              onClick={() => handleSync(currentItem)}
            >
              {(employeesState.loading === "pending" &&
                employeesState.action === "sync-from-sap") && <div className="spinner-border spinner-border-sm" role="status"></div>}
              {` Sync Employee`}
            </button>
          </div>


          <div className="col-md-12 mt-4">
            <SyncNocRequest nocType={'NOC_OUTJOB'} empId={currentItem} />
          </div>

          <div className="col-md-12 mt-4">
            <SyncNocRequest nocType={'VISA-PASSPORT'} empId={currentItem} />
          </div>

          <div className="col-md-12 mt-4">
            <SyncNocRequest nocType={'EX-INDIA'} empId={currentItem} />
          </div>

          <div className="col-md-12 mt-4">
            <SyncNocRequest nocType={'HIGHER-STUDIES'} empId={currentItem} />
          </div>

          <div className="col-md-12 mt-4">
            <SyncNocRequest nocType={'ONLINE-COURSE'} empId={currentItem} />
          </div>

          <div className="col-md-12 mt-4">
            <button
              className="btn btn-primary w-100"
              type="button"
              onClick={() => handleSyncLoanData(currentItem)}
              disabled={syncingLoan}
            >
              {syncingLoan && <div className="spinner-border spinner-border-sm me-2" role="status"></div>}
              {` Sync Loan Data`}
            </button>
          </div>


        </div>



      </AntdModal>
    </div>
  );
};

export default EmployeesList;
